import React from 'react'
import ObjectArrayInput from 'src/components/inputs/arrays/ObjectArrayInput'
import { IInputProps } from 'src/types'

export function ColorArrayInput(props: IInputProps<string[]>): JSX.Element {
  const propsWithItems: IInputProps<string[]> = {
    ...props,
    property: {
      ...props.property,
      items: {
        ...props.property.items,
        type: 'color',
      },
    },
  }
  console.debug('ColorArrayInput', propsWithItems)
  return (
    <ObjectArrayInput<string>
      {...propsWithItems}
      itemInitialValue='#FFFFFF'
    />
  )
}
